import type { IUniversalMenuItemWithCustomFields } from '@klaviyo-mkt/components/shared/types';

export const transformMenuItems = (items: IUniversalMenuItemWithCustomFields[]): IUniversalMenuItemWithCustomFields[] => {
  // Create a map of all items by their ID for quick lookup
  const itemsMap = new Map<string, IUniversalMenuItemWithCustomFields>();
  items.forEach(item => {
    // Create fields needed to pass into UniversalNavigation if we want to reuse that component
    const { uri, ...rest } = item as any;
    itemsMap.set(item.id, { 
      ...rest, 
      url: uri || rest.url,
      childItems: item.childItems || [],
      // Ensure all required fields are present
      id: item.id,
      label: item.label,
      locale: item.locale || 'en-US',
      order: item.order || 0,
      target: item.target || null,
      type: item.type || 'link_list',
      width: item.width || 'standard',
      position: item.position || 'upper',
    });
  });

  // Build the hierarchy
  const rootItems: IUniversalMenuItemWithCustomFields[] = [];
  
  items.forEach(item => {
    const menuItem = itemsMap.get(item.id);
    if (!menuItem) return;

    // If the item has a parentId, add it to its parent's childItems
    if (item.parentId && itemsMap.has(item.parentId)) {
      const parent = itemsMap.get(item.parentId);
      if (parent) {
        parent.childItems = parent.childItems || [];
        // Only add the item if it's not already in the childItems array
        if (!parent.childItems.some(child => child.id === menuItem.id)) {
          parent.childItems.push(menuItem);
        }
      }
    } else {
      // If no parentId, it's a root item
      rootItems.push(menuItem);
    }
  });

  return rootItems;
}; 
